import { Injectable } from '@angular/core'
import { FormattedSchoolType } from 'src/app/interfaces/school-ideal-type'
import { SchoolIdealTypeLogEvent } from '../../../interfaces/log/school-ideal-type-log'
import { LogService } from '../log.service'

@Injectable({
  providedIn: 'root',
})
export class SchoolIdealTypeLogService {
  constructor(private logService: LogService) {}
  //[메인] (웹)배너 클릭
  logHomeSchoolIdealTypeClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.HOME_SOCIAL_CONTENT_SCHOOL_IDEAL_TYPE_CLICKED)
  }
  //[온보딩] 화면 진입
  logOnboardingViewed() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ONBOARDING_VIEWED)
  }
  //[온보딩] 홈버튼 클릭
  logOnboardingHomeButtonClicked() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ONBOARDING_HOME_BUTTON_CLICKED)
  }
  //[온보딩] 참여하기 버튼 클릭
  logOnboardingParticipateButtonClicked(location: 'top' | 'bottom') {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ONBOARDING_PARTICIPATE_BUTTON_CLICKED, {
      location,
    })
  }
  //[온보딩] 공유 버튼 클릭
  logOnboardingShareButtonClicked(type: 'kakao' | 'qr' | 'x' | 'link') {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ONBOARDING_SHARE_BUTTON_CLICKED, { type })
  }
  //[온보딩] 로그인 모달 진입
  logOnboardingLoginModalViewed() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ONBOARDING_LOGIN_MODAL_VIEWED)
  }
  //[온보딩] 로그인 버튼 클릭
  logOnboardingLoginButtonClicked() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ONBOARDING_LOGIN_BUTTON_CLICKED)
  }
  //[신청 정보 입력] 화면 진입
  logInfoInputViewed(type: 'gender' | 'school' | 'admission_year' | 'major' | 'name') {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_INFO_INPUT_VIEWED, { type })
  }
  //[신청 정보 입력] 다음 버튼 클릭
  logInfoInputNextButtonClicked(type: 'gender' | 'school' | 'admission_year' | 'major' | 'name') {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_INFO_INPUT_NEXT_BUTTON_CLICKED, { type })
  }
  //[총 입력 결과] 신청하기 버튼 클릭
  logTotalInfoInputResultParticipateButtonClicked() {
    this.logService.eventLogging(
      SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_TOTAL_INFO_INPUT_RESULT_PARTICIPATE_BUTTON_CLICKED
    )
  }
  //[신청 결과] 화면 진입
  logParticipateResultViewed() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_VIEWED)
  }
  //[신청 결과] 공유 버튼 클릭
  logParticipateResultShareButtonClicked(type: 'kakao' | 'copy' | 'qr') {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_SHARE_BUTTON_CLICKED, {
      type,
    })
  }
  //[신청 결과] 알림 버튼 클릭
  logParticipateResultAlarmButtonClicked() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_ALARM_BUTTON_CLICKED)
  }
  //[신청 결과] 홈 버튼 클릭
  logParticipateResultHomeButtonClicked() {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_HOME_BUTTON_CLICKED)
  }
  // [신청 결과] 내 프로필 클릭
  logSchoolIdealTypeParticipateResultProfileButtonClick(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_PROFILE_BUTTON_CLICK)
  }
  // [프로필 입력 - MBTI] 화면 진입
  logSoulmateProfileInputMbtiViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_MBTI_VIEWED)
  }
  // [프로필 입력 - MBTI] 다음 버튼 클릭
  logSoulmateProfileInputMbtiNextButtonClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_MBTI_NEXT_BUTTON_CLICKED)
  }
  // [프로필 입력 - MBTI] 목록 화면 진입
  logSoulmateProfileInputMbtiListViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_MBTI_LIST_VIEWED)
  }
  // [프로필 입력 - MBTI] 퀴즈 클릭
  logSoulmateProfileInputMbtiQuizClicked(type: 'quiz' | 'new'): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_MBTI_QUIZ_CLICKED, { type })
  }
  // [프로필 입력 - 이상형] 화면 진입
  logSoulmateProfileInputIdealViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_IDEAL_VIEWED)
  }
  // [프로필 입력 - 이상형] 다음 버튼 클릭
  logSoulmateProfileInputIdealNextButtonClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_IDEAL_NEXT_BUTTON_CLICKED)
  }
  // [프로필 입력 - 이상형] 목록 화면 진입
  logSoulmateProfileInputIdealListViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_IDEAL_LIST_VIEWED)
  }
  // [프로필 입력 - 이상형] 퀴즈 클릭
  logSoulmateProfileInputIdealQuizClicked(type: 'quiz' | 'new'): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SOULMATE_PROFILE_INPUT_IDEAL_QUIZ_CLICKED, { type })
  }

  //[스테이징] 화면 진입
  logSchoolIdealTypeStagingViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_STAGING_VIEWED)
  }
  //[신청 결과] 유형 정보 입력하기 클릭
  logSchoolIdealTypeParticipateResultInputInfoButtonClicked(type: 'mbti' | 'idealType'): void {
    this.logService.eventLogging(
      SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_INPUT_INFO_BUTTON_CLICKED,
      { type }
    )
  }
  //[신청 결과] 프로필 수정 클릭
  logSchoolIdealTypeParticipateResultUpdateProfileClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PARTICIPATE_RESULT_UPDATE_PROFILE_CLICKED)
  }
  //[뽑기] 화면 진입
  logSchoolIdealTypeRouletteScreenViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_SCREEN_VIEWED)
  }
  //[뽑기] 뽑기 버튼 클릭
  logSchoolIdealTypeRouletteRouletteButtonClicked(totalStudentCount: number): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_ROULETTE_BUTTON_CLICKED, {
      totalStudentCount,
    })
  }
  //[뽑기] 뽑기 성공
  logSchoolIdealTypeRouletteRouletteSuccess(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_ROULETTE_SUCCESS)
  }
  //[뽑기] 뽑기 실패
  logSchoolIdealTypeRouletteRouletteFail(reason: 'no_mbti' | 'no_ideal' | 'no_pool' | 'error'): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_ROULETTE_FAIL, { reason })
  }
  //[뽑기] 공유 버튼 클릭
  logSchoolIdealTypeRouletteShareButtonClicked(type: 'kakao' | 'copy' | 'qr'): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_SHARE_BUTTON_CLICKED, { type })
  }
  //[뽑기] 프로필 클릭
  logSchoolIdealTypeRouletteProfileButtonClick(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_PROFILE_BUTTON_CLICKED)
  }
  //[뽑기] 끝까지 기다리고 결과로 이동
  logschoolIdealTypeRouletteWaitRouletteAnimation(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_WAIT_ROULETTE_ANIMATION)
  }
  //[뽑기] staging 중 카드 클릭해서 바로 결과로 이동
  schoolIdealTypeRouletteCardClickedOnAnimation(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_CARD_CLICKED_ON_ANIMATION)
  }
  //[프로필] 화면 진입
  logSchoolIdealTypeProfileScreenViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PROFILE_SCREEN_VIEWED)
  }

  //[프로필] 프로필 편집 클릭
  logSchoolIdealTypeProfileUpdateProfileClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PROFILE_UPDATE_PROFILE_CLICKED)
  }
  //[프로필] 유형 정보 수정 클릭
  logSchoolIdealTypeProfileUpdatePersonalityClicked(type: 'mbti' | 'idealType'): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PROFILE_UPDATE_PERSONALITY_CLICKED, { type })
  }
  //[프로필]  유형 정보 등록 클릭
  logSchoolIdealTypeProfileInputPersonalityClicked(type: 'mbti' | 'idealType'): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PROFILE_INPUT_PERSONALITY_CLICKED, { type })
  }
  //[프로필 편집] 화면 진입
  logSchoolIdealTypeProfileUpdateScreenViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PROFILE_UPDATE_SCREEN_VIEWED)
  }
  //[프로필 편집] 저장 클릭
  logSchoolIdealTypeProfileSaveButtonClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_PROFILE_SAVE_BUTTON_CLICKED)
  }
  //[뽑기] (웹)앱으로 결과보기 모달 진입
  logSchoolIdealTypeRouletteAppModalViewed(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_APP_MODAL_VIEWED)
  }
  //[뽑기] (웹)앱에서 보기 클릭
  logSchoolIdealTypeRouletteAppButtonClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_APP_BUTTON_CLICKED)
  }
  //[뽑기] (웹)버릴래요 클릭
  logSchoolIdealTypeRouletteDiscardButtonClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_DISCARD_BUTTON_CLICKED)
  }
  //[뽑기] (웹)결과 볼래요 클릭
  logSchoolIdealTypeRouletteResultButtonClicked(): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_ROULETTE_RESULT_BUTTON_CLICKED)
  }
  logSchoolIdealTypeInfoInputGraduateModalViewed(schoolType: FormattedSchoolType): void {
    this.logService.eventLogging(SchoolIdealTypeLogEvent.SCHOOL_IDEAL_TYPE_INFO_INPUT_GRADUATE_MODAL_VIEWED, {
      schoolType,
    })
  }
}
